import { createSlice, EntityState, PayloadAction } from '@reduxjs/toolkit';

import { Contact, Message } from '@/types/chat/chat.types';

import { contactsAdapter, messagesAdapter } from './chat.adapters';

export type ChatState = {
  contacts: EntityState<Contact, string>;
  messages: EntityState<Message, number>;
  newMessageEntry: boolean;
};

export const CHAT_INITIAL_STATE: ChatState = {
  contacts: contactsAdapter.getInitialState(),
  messages: messagesAdapter.getInitialState(),
  newMessageEntry: false,
};

export const chat = createSlice({
  name: 'chat',
  initialState: CHAT_INITIAL_STATE,
  reducers: {
    addContact({ contacts }, action: PayloadAction<Contact>) {
      contactsAdapter.addOne(contacts, action.payload);
    },
    updateContact({ contacts }, action: PayloadAction<Contact>) {
      contactsAdapter.upsertOne(contacts, action.payload);
    },
    deleteContact({ contacts }, action: PayloadAction<Contact>) {
      contactsAdapter.removeOne(contacts, action.payload.code);
    },
    updateContacts({ contacts }, action: PayloadAction<Contact[]>) {
      contactsAdapter.setAll(contacts, action.payload);
    },
    addMessage({ messages }, action: PayloadAction<Message>) {
      messagesAdapter.addOne(messages, action.payload);
    },
    addMessages({ messages }, action: PayloadAction<Message[]>) {
      messagesAdapter.addMany(messages, action.payload);
    },
    updateNewMessageEntry(state, action: PayloadAction<boolean>) {
      state.newMessageEntry = action.payload;
    },
  },
});

export const {
  addContact,
  updateContact,
  deleteContact,
  updateContacts,
  addMessage,
  addMessages,
  updateNewMessageEntry,
} = chat.actions;

export default chat.reducer;
